import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { NoteContextMenu } from "../../../../shared/lib/types/notes-model/notes-model"


type ContextMenusInit = {
    entities: NoteContextMenu[],
    error: string | null
}

export const initialStateContext: ContextMenusInit = {
    entities: [],
    error: null
}

export const contextNotesSlice = createSlice({
    name: 'notesContext',
    initialState: initialStateContext,
    selectors: {
        selectAllContexts: (state) => state.entities,
        selectContextById: (state, id: string) => state.entities.find((el) => el.contextId === id) 
    },
    reducers: {
        addContext: (state, action: PayloadAction<{id: string}>) => {
            if (!state.entities.find(el => el.contextId === action.payload.id)) {
                const newNote: NoteContextMenu = {
                    contextIsOpen: false,
                    contextId: action.payload.id
                }
                state.entities.push(newNote)            
            }
        },
        removeContext: (state, action: PayloadAction<{id: string}>) => {
            state.entities = state.entities.filter(el => el.contextId !== action.payload.id)            
        },
        updateContext: (state, action: PayloadAction<{id: string}>) => {
            state.entities.map(onContext => onContext.contextId === action.payload.id ? onContext.contextIsOpen = true : onContext.contextIsOpen = false)
        },
        closeContext: (state, action: PayloadAction<{id: string}>) => {
            const context = state.entities.find(c => c.contextId === action.payload.id)
            if (context) context.contextIsOpen = false
        }
    }
})